import React, { useState } from "react"
import { CollectionIcon } from "@heroicons/react/outline"
import { EndpointConfig } from "../../config"
import { axiosInstance } from "../../lib/axios"
import Button from "../atoms/button.atom"
import Input from "../atoms/input.atom"
import { toast } from "react-toastify"
import * as yup from "yup"
import { validateYup } from "../template-info/templateUtils"
import { Header } from "../common/header"
import Loader from "../loader/loader.component"
import { getCookie } from "../../helper/auth"

export const AllDLTEntityId = ({ hubId }) => {
	const [form, setForm] = React.useState({
		dltentityId: ""
	})
	const [loading, setLoading] = React.useState(false)
	const [errors, setErrors] = React.useState({})
	const [dataDLTEntityId, setDataDLTEntityId] = useState([])

	const getDLTEntityId = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			const res = await axiosInstance.get(EndpointConfig.hubAppConfigDLTEntityId, {
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
			setDataDLTEntityId(res.data.data)
			setForm({ dltentityId: res.data.data[0]?.dltentityId })
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	React.useEffect(() => {
		getDLTEntityId()
	}, [])

	const addRecord = () => {
		setLoading(true)
		;(async () => {
			const token = getCookie("token")
			await axiosInstance.post(
				EndpointConfig.hubAppConfigDLTEntityId,
				{
					dltentityId: form.dltentityId
				},
				{
					headers: {
						Authorization: `Bearer ${token}`
					}
				}
			)
			toast("Added Successfully")
			getDLTEntityId()
		})()
			.catch(console.err)
			.finally(() => setLoading(false))
	}

	const editRecord = () => {
		let schema = yup.object().shape({
			dltentityId: yup.string().trim().required("Required")
		})
		let finalObj = {
			hubId: hubId,
			recordId: dataDLTEntityId[0]._id,
			dltentityId: form.dltentityId
		}
		validateYup(schema, finalObj)
			.then(() => {
				setErrors({})
				setLoading(true)
				;(async () => {
					const token = getCookie("token")
					await axiosInstance.put(EndpointConfig.hubAppConfigDLTEntityId, finalObj, {
						headers: {
							Authorization: `Bearer ${token}`
						}
					})
					toast("Updated Successfully")
				})()
					.catch(console.err)
					.finally(() => setLoading(false))
			})
			.catch(setErrors)
	}

	return (
		<>
			<div className="flex flex-col">
				<Header IconName={CollectionIcon} subText={"List"} mainText={"DLT Entitiy Id"} />

				{loading ? (
					<Loader />
				) : (
					<>
						<div className="flex flex-col pb-4 overflow-x-auto bg-white rounded">
							<div className="inline-block min-w-full py-2">
								<div className="flex flex-col gap-1 p-4 bg-white rounded">
									<div className="flex flex-row gap-6">
										<Input
											name="DLT Entitiy Id"
											error={errors?.dltentityId}
											value={form.dltentityId}
											label={"DLT Entitiy Id"}
											placeholder={"DLT Entitiy Id"}
											onChange={(e) =>
												setForm({ ...form, dltentityId: e.target.value })
											}
										/>
										<div className="flex flex-row gap-6 my-8">
											<div className="flex-1">
												{loading ? (
													<Button className="w-full text-black bg-red-100 pointer-events-none ">
														Loading
													</Button>
												) : (
													<>
														{dataDLTEntityId.length > 0 ? (
															<Button
																className="w-full "
																onClick={editRecord}
															>
																Update
															</Button>
														) : (
															<Button
																className="w-full "
																onClick={addRecord}
															>
																Add
															</Button>
														)}
													</>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>
		</>
	)
}
